// extracted by mini-css-extract-plugin
export default {"statics":"Statics_statics__IWY0w","active":"Statics_active__tI6l1"};